export enum BillingModuleType {
    CoreUsersCharge = 1,
    CoreUnitsCharge = 2,
    Checklists = 3,
    SslCerts = 4,
    SslCertsUnitCharge = 5,
    sslCertsUserCharge = 6,
}
